import { createPortal } from "react-dom";

import { MarkerType } from "@/src/map/MapMarker";

import type { IComponent } from "../Component";
import { Component } from "../Component";

export interface IMapMarker extends IComponent {
    map: google.maps.Map;
    iconUrl: string;
    position: google.maps.LatLngLiteral;
    onLoad?: (marker: google.maps.Marker) => void;
    showInfo?: boolean;
    renderInfoContent: (props: IMapMarker) => JSX.Element;
    onOpenInfo?: () => void;
    onCloseInfo?: () => void;
    shouldAnimate?: boolean;
    markerType: MarkerType;
}

export class MapMarker extends Component<IMapMarker> {
    private marker: google.maps.Marker;

    private infoWindow: google.maps.InfoWindow;

    private googleDiv: HTMLDivElement;

    public componentDidMount() {
        this.marker = new google.maps.Marker({
            icon:
                this.props.markerType === MarkerType.ShoppingMall
                    ? "https://images.goodie.pl/v3/Z29vZGllLWFzc2V0cy9pbWFnZXMvTG9jYXRpb24vcG9pbnRlcl9nYWxsZXJ5X3NtYWxsLnBuZw"
                    : "https://images.goodie.pl/v3/L2dvb2RpZS1hc3NldHMvaW1hZ2VzL0xvY2F0aW9uL3BvaW50ZXJfbWVyY2hhbnQucG5n",
            position: this.props.position,
            map: this.props.map,
            animation: this.props.shouldAnimate ? google.maps.Animation.DROP : undefined,
        });

        this.marker.addListener("click", this.onClick);

        if (this.props.onLoad) {
            this.props.onLoad(this.marker);
        }
    }

    public shouldComponentUpdate(nextProps: IMapMarker) {
        return nextProps.showInfo !== this.props.showInfo;
    }

    public componentWillUnmount() {
        this.marker.setMap(null);
    }

    private onOpen() {
        if (this.props.onOpenInfo) {
            this.props.onOpenInfo();
        }
    }

    private openInfo = () => {
        if (!this.props.map || !this.props.renderInfoContent) {
            return;
        }

        if (this.infoWindow) {
            this.infoWindow.open(this.props.map, this.marker);
            return;
        }

        this.googleDiv = document.createElement("div");

        this.infoWindow = new google.maps.InfoWindow({ content: this.googleDiv });
        this.infoWindow.open(this.props.map, this.marker);

        this.infoWindow.addListener("closeclick", this.onClose);
    };

    private closeInfo = () => {
        if (!this.props.map) {
            return;
        }

        if (this.infoWindow) {
            this.infoWindow.close();
        }
    };

    private onClick = () => {
        if (this.props.showInfo === false) {
            this.onOpen();
        } else {
            this.onClose();
        }
    };

    private onClose = () => {
        if (this.props.onCloseInfo) {
            this.props.onCloseInfo();
        }
    };

    public render() {
        if (this.props.showInfo === false) {
            this.closeInfo();
            return null;
        }

        this.openInfo();

        return createPortal(this.props.renderInfoContent(this.props), this.googleDiv);
    }
}
